import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createEmployee = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/employee/add`, data);
  return res.data;
};

export const updateEmployee = async ({ data, id, vendor_id }) => {
  const res = await axios.patch(
    `${API_BASE_URL}/employee?employee_id=${vendor_id}&user_id=${id}`,
    data
  );
  return res.data;
};

export const getAllEmployee = async (data) => {
  const { id, type } = JSON.parse(sessionStorage.getItem("info"));

  const res = await axios.get(
    `${API_BASE_URL}/employee?user_id=${id}&user_type=${type}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getEmployeeById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/employee/${id}`);
  return res.data;
};
